import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import zChat from '../../vendor/web-sdk';
import CardContainer from './CardContainer';
import MessageSvg from './MessageSvg';
import ActionButton from './ActionButton';
import countryList from '../constants/countries';
import departments from '../constants/departments';

export default function PreChatForm() {
  const [sent, setSent] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const countryOfBirth = watch('countryOfBirth');
  const countryOfApplication = watch('countryOfApplication');
  const numberOfapplicants = watch('numberOfapplicants');
  const lengthOfStay = watch('lengthOfStay');

  const department = zChat.getDepartment(departments.SALES);

  // Set departments to SALES

  if (department && department.id !== undefined) {
    if (department.status !== 'online') {
      document.querySelector('#grs-chat-widget').remove();
    }

    zChat.setVisitorDefaultDepartment(department.id, () => {});
  }

  const onSubmit = (data) => {
    const { name, email, phone, reasonOfContact } = data;

    const allInfo = `
    Name: ${name || '--'}
    Email: ${email || '--'}
    Phone: ${phone || '--'}
    Country of Birth: ${countryOfBirth || '--'}
    Country of Application: ${countryOfApplication || '--'}
    Total Number of Applicants: ${numberOfapplicants || '--'}
    Length Of Stay: ${lengthOfStay || '--'}
    Why you want/need the Visa: ${reasonOfContact || '--'}`;

    console.log(allInfo);
    zChat.setVisitorInfo(
      {
        display_name: name,
        email,
      },
      (err) => {
        if (err) return;
        zChat.sendChatMsg(allInfo, (err2) => {
          if (err2) console.log('Error sending message');
        });
      }
    );

    setSent(true);
    useDispatch({
      type: 'synthetic',
      detail: {
        type: 'visitor_send_msg',
        msg: '',
      },
    });
    console.log(data);
  };

  return (
    <CardContainer
      title="Introduce yourself!"
      addClass="offline-card"
      contentAddClass={sent ? 'sent' : ''}
      icon={<MessageSvg />}
    >
      <form
        key="not-sent"
        className="offline-form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="content">
          <div className="section">
            <label className="label">Full Name</label>
            <input
              className={errors.name ? 'invalid-input' : ''}
              {...register('name', {
                required: true,
                pattern: /^(?! )[A-Za-z\s]+$/i,
              })}
            />
            {errors.name?.type === 'required' && (
              <div className="text-red">Name is required</div>
            )}
            {errors.name?.type === 'pattern' && (
              <div className="text-red">Please enter a valid name</div>
            )}
          </div>
          <div className="section">
            <label className="label">Email</label>
            <input
              className={errors.email ? 'invalid-input' : ''}
              {...register('email', {
                required: true,
                pattern:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              })}
            />
            {errors.email?.type === 'required' && (
              <div className="text-red">Email is required</div>
            )}
            {errors.email?.type === 'pattern' && (
              <div className="text-red">Enter a valid email</div>
            )}
          </div>
          <div className="section">
            <label className="label">Phone Number</label>
            <input
              className={errors.phone ? 'invalid-input' : ''}
              {...register('phone', {
                required: true,
              })}
            />
            {errors.phone?.type === 'required' && (
              <div className="text-red">Phone is required</div>
            )}
          </div>
          <div className="section">
            <label className="label">Country of Birth</label>
            <select
              {...register('countryOfBirth', {
                required: true,
              })}
              className={errors.countryOfBirth ? 'invalid-input' : ''}
            >
              {!countryOfBirth && <option value="">Select a country</option>}
              {Object.entries(countryList)
                .sort(([, country1], [, country2]) =>
                  country1.localeCompare(country2)
                )
                .map(([code, country]) => (
                  <option value={`${country} (${code})`}>{country}</option>
                ))}
            </select>
            {errors.countryOfBirth?.type === 'required' && (
              <div className="text-red">Country of Birth is required</div>
            )}
          </div>
          <div className="section">
            <label className="label">Country of Application</label>
            <select
              {...register('countryOfApplication', {
                required: true,
              })}
              className={errors.countryOfApplication ? 'invalid-input' : ''}
            >
              {!countryOfApplication && (
                <option value="">Select a country</option>
              )}
              {Object.entries(countryList)
                .sort(([, country1], [, country2]) =>
                  country1.localeCompare(country2)
                )
                .map(([code, country]) => (
                  <option value={`${country} (${code})`}>{country}</option>
                ))}
            </select>
            {errors.countryOfApplication?.type === 'required' && (
              <div className="text-red">Country of Application is required</div>
            )}
          </div>
          <div className="section">
            <label className="label">Total Number of Applicants</label>
            <select
              {...register('numberOfapplicants', {
                required: true,
              })}
              className={errors.numberOfapplicants ? 'invalid-input' : ''}
            >
              {!numberOfapplicants && <option value="">Select</option>}
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10+</option>
            </select>
            {errors.numberOfapplicants?.type === 'required' && (
              <div className="text-red">Number of Applicants is required</div>
            )}
          </div>
          <div className="section">
            <label className="label">Length of Stay</label>
            <select
              {...register('lengthOfStay', {
                required: true,
              })}
              className={errors.lengthOfStay ? 'invalid-input' : ''}
            >
              {!lengthOfStay && <option value="">Select</option>}
              <option>Less than 1 week</option>
              <option>1 week or more (and less than a month)</option>
              <option>1 month or more (and less than 3 months)</option>
              <option>3 months or more (and less than 6 months)</option>
              <option>6 months or more (and less than 1 year)</option>
              <option>1 year or more</option>
              <option>Not sure</option>
            </select>
            {errors.lengthOfStay?.type === 'required' && (
              <div className="text-red">Length of Stay is required</div>
            )}
          </div>
          <div className="section">
            <label className="label">
              Share with me some details about why you want/need the Visa to
              prepare for our meeting.
            </label>
            <textarea
              className={errors.reasonOfContact ? 'invalid-input' : ''}
              {...register('reasonOfContact', {
                required: true,
                pattern: /^(?:(?! ).*)|(?:\s?[^ ]+.*)$/i,
              })}
            />
            {errors.reasonOfContact?.type === 'required' && (
              <div className="text-red">Reason of Contact is required</div>
            )}

            {errors.reasonOfContact?.type === 'pattern' && (
              <div className="text-red">Please enter a reason of contact</div>
            )}
          </div>
        </div>
        {true && (
          <div className="button-container">
            <ActionButton addClass="button-send" label="Send" />
          </div>
        )}
      </form>
    </CardContainer>
  );
}
